export function validatePassword(password) {
  const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;

  if (!password || password.length < 8) {
    return "Password must be at least 8 characters long.";
  }

  if (!specialCharRegex.test(password)) {
    return "Password must include at least one special character.";
  }

  return "";
}
